import preact, { Component, h } from 'preact'
import ImageUploader from '../category/control/ImageUploader'
import Button from '../ui-components/Button'
import InputGroup from '../ui-components/InputGroup'
import axios from 'axios'

interface Props {
  title: string,
  onChange: (state: {title: string}) => void
}

const Hero = (_: Props) => (
  <div className='sitewidth text-center'>
    <h1 className='ideas-overview-wrapper-title'>Ideas</h1>
  </div>
)

interface PropsForConfigurator {
  onChange: (state: { hero_image: string, title: string, tagline: string }) => void,
  heroImage: string,
  title: string,
  tagline: string
}

interface State {
  src: null | string,
  crop: {
    x: number,
    y: number,
    width: number,
    height: number,
    aspect: number
  },
  pixelCrop: {
    width: number,
    height: number,
    x: number,
    y:number
  },
  errorMessage: null | string,
  hero_image: string,
  title: string,
  tagline: string
}

export class HeroWithHelp extends Component<PropsForConfigurator, State> {
  constructor (props: PropsForConfigurator) {
    super(props)
    this.state = {
      src: null,
      crop: {
        x: 0,
        y: 0,
        width: 96,
        height: 16,
        aspect: 6
      },
      pixelCrop: {
        width: 96,
        height: 16,
        x: 0,
        y: 0
      },
      errorMessage: null,
      hero_image: props.heroImage,
      title: props.title,
      tagline: props.tagline
    }
    this.uploader = preact.createRef()

    this.saveImage = this.saveImage.bind(this)
    this.cancelUpload = this.cancelUpload.bind(this)
  }

  uploader: preact.RefObject

  async saveImage () {
    try {
      let element: HTMLInputElement | null = document.querySelector('input#csrftoken')

      let csrf: string = ''
      if (element !== null) {
        csrf = element.value
      }

      let formData = new window.FormData()
      const file = this.uploader.files[0]

      formData.append('image', file)
      formData.append('yip_csrf_token', csrf)
      formData.append('crop_coords[x]', Math.round(this.state.pixelCrop.x).toString())
      formData.append('crop_coords[y]', Math.round(this.state.pixelCrop.y).toString())
      formData.append('crop_coords[width]', Math.round(this.state.pixelCrop.width).toString())
      formData.append('crop_coords[height]', Math.round(this.state.pixelCrop.height).toString())

      const res = await axios.post('/attachment/new', formData)
      const { source_thumb } = res.data
      this.setState({ hero_image: source_thumb, src: null })
    } catch (e) {
      console.log(e)
    }
  }

  cancelUpload () {
    this.setState({ src: null })
    this.uploader.value = ''
  }

  componentWillUpdate (nextProps: PropsForConfigurator, nextState: State) {
    if (nextProps.onChange && this.state !== nextState) {
      nextProps.onChange({ hero_image: nextState.hero_image, title: nextState.title, tagline: nextState.tagline })
    }
  }

  render (props : PropsForConfigurator, state: State) {
    const isForum = window.inSidedData?.communityId

    return (
      <div className='hero-banner-wrapper'>
        <InputGroup
          title='Title'
          name='title'
          placeholder='Add a title'
          type='text'
          onChange={(e: preact.ChangeEvent<HTMLInputElement>) => this.setState({ title: e.target.value })}
          value={state.title} />
        <InputGroup
          title='Tagline'
          name='tagline'
          placeholder='Add a tagline'
          type='text'
          onChange={(e: preact.ChangeEvent<HTMLInputElement>) => this.setState({ tagline: e.target.value })}
          value={state.tagline} />
        <label>Hero image</label>
        <p>Maximum file size: 5m. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px</p>
        {
          state.hero_image ? (
            <div className='hero-image-container'>
              <div className='hero-image-wrapper'>
                <img src={state.hero_image} />
                <a target='_blank' href={state.hero_image} class='component-uploader__image-details'>
                  2880px &times; 480px <i class='icon icon-external' />
                </a>
              </div>
              <div className='hero-image_buttons'>
                <Button
                  type='button'
                  class={`${!isForum ? 'btn-default' : ''} btn--insided-secondary-brand`}
                  onClick={() => this.uploader.click()}
                >
                  Edit
                </Button>
                <Button
                  type='button'
                  class={`${!isForum ? 'btn-default' : ''} btn--insided-secondary-brand btn-delete`}
                  onClick={() => this.setState({ hero_image: '' })}
                >
                  Remove
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <Button
                type='button'
                class={`${!isForum ? 'btn-default btn-primary' : ''} btn--insided-secondary-brand`}
                onClick={() => this.uploader.click()}
              >
                Upload image
              </Button>
            </div>
          )
        }
        <ImageUploader
          width={2880}
          height={480}
          onUploaded={({ source_thumb }: { source_thumb: string }) => this.setState({ hero_image: source_thumb })}
          uploaderRef={(ref: preact.RefObject) => { this.uploader = ref }}
        />
      </div>
    )
  }
}

export default Hero
